export const EDITOR_QUICK_PICK_ROLL_TIMING = {
  lockStagger: 40,
  minLockTime: 160,
  tick: 45,
  total: 420,
} as const

export const EDITOR_QUICK_PICK_GRID_TIMING = {
  lockStagger: 70,
  minLockTime: 0,
  tick: 80,
  total: 560,
} as const

export const EDITOR_QUICK_PICK_BATCH_CASCADE = 70

export const EDITOR_QUICK_PICK_GLOW_IN = 160

export const EDITOR_QUICK_PICK_GLOW_OUT = 520

export const EDITOR_QUICK_PICK_COLLAPSE_TIMEOUT = 360

export const EDITOR_QUICK_PICK_SETTLE_DURATION = 220

export const EDITOR_QUICK_PICK_SETTLE = EDITOR_QUICK_PICK_SETTLE_DURATION + 40

export const EDITOR_QUICK_PICK_VISIBILITY_TIMEOUT = 1000

// style v-bind() only sees local bindings, so the pickers alias this object instead of the imports
export const EDITOR_QUICK_PICK_MOTION = {
  settle: EDITOR_QUICK_PICK_SETTLE_DURATION,
  tick: EDITOR_QUICK_PICK_ROLL_TIMING.tick,
} as const
